import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { Offer } from '../../models/models';
import { HeaderService } from '../../services/header.service';
import { OfferService } from '../../services/offer.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSearchOfferComponent } from '../../sections/modal-search-offer/modal-search-offer.component';
import { AuthGuard } from '../../services/auth/auth.guard';

@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
})
export class OfferListComponent implements OnInit {
  offers: Offer[];
  offersCount: number;
  showMoreBtn: boolean;

  draftText: string;
  blockedText: string;

  search_statusId: string;
  search_offerKindId: string;
  search_statusName: string;
  search_offerKindName: string;
  search_dateStart: Date;
  search_dateEnd: Date;
  search_name: string;
  search_userId: number | null = null;

  constructor(
    private title: Title,
    private translate: TranslateService,
    private headerService: HeaderService,
    private offersService: OfferService,
    private modalService: NgbModal,
    private authGuard: AuthGuard,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.translate.get('Pages.OfferList').subscribe((res: any) => {
      this.title.setTitle(res.Title);
      this.draftText = res.List.Draft;
      this.blockedText = res.List.Blocked;

      if (this.route.snapshot.data.offers) {
        this.offers = this.route.snapshot.data.offers;
      }
      this.offersCount = this.route.snapshot.data.offersCount;
      this.headerService.setPageTitle(true, this.route.snapshot.data.activityCount, '');

      this.searchAll();
    });
  }

  showMore() {
    this.search(this.offers.length, true);
  }

  defineShowMore() {
    this.showMoreBtn = this.offersCount > this.offers.length;
  }

  showSearch() {
    const modalRef = this.modalService.open(ModalSearchOfferComponent);
    modalRef.componentInstance.statusId = this.search_statusId;
    modalRef.componentInstance.offerKindId = this.search_offerKindId;
    modalRef.componentInstance.dateStart = this.search_dateStart;
    modalRef.componentInstance.dateEnd = this.search_dateEnd;

    modalRef.componentInstance.passEntry.subscribe((result: any) => {
      this.search_statusId = result.statusId;
      this.search_offerKindId = result.offerKindId;
      this.search_dateStart = result.dateStart;
      this.search_dateEnd = result.dateEnd;
      this.search_statusName = result.statusName;
      this.search_offerKindName = result.offerKindName;

      this.search(0, false);
    });
  }

  searchByUser() {
    this.search_userId = this.authGuard.userId;
    this.search(0, false);
  }

  searchAll() {
    this.search_userId = null;
    this.search(0, false);
  }

  search(skip: number, concat: boolean) {
    this.offersService
      .getAll(
        this.authGuard.userId,
        this.search_userId,
        this.search_statusId,
        this.search_offerKindId,
        this.search_dateStart,
        this.search_dateEnd,
        this.search_name,
        skip,
        5
      )
      .subscribe((res: any) => {
        if (concat) {
          this.offers = this.offers.concat(res);
        } else {
          this.offers = res;
        }
        this.offersService
          .getCount(
            this.authGuard.userId,
            this.search_userId,
            this.search_statusId,
            this.search_offerKindId,
            this.search_dateStart,
            this.search_dateEnd,
            this.search_name
          )
          .subscribe((count: number) => {
            this.offersCount = count;
            this.defineShowMore();
          });
      });
  }
}
